import React from "react";
import { Link } from "react-router-dom";
import IcLogo from "../../images/logo.svg";

const Logo = ({ color = "text-primary" }) => {
  return (
    <Link to={"/"} className="flex items-center gap-2">
      <img src={IcLogo} alt="Logo Hallo Doctor" width={38} height={36} />
      <h1 className={`${color} font-bold font-lato leading-none`}>
        Hallo
        <br />
        Doctor
      </h1>
    </Link>
  );
};

export default Logo;
